"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultMaskOptions = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _parse2 = _interopRequireDefault(require("date-fns/parse"));

var _format2 = _interopRequireDefault(require("date-fns/format"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));

var _MaskedInput = _interopRequireDefault(require("../masked-input/MaskedInput"));

var _CustomDateMask = _interopRequireDefault(require("./CustomDateMask"));

var _CustomRangeMask = _interopRequireDefault(require("./CustomRangeMask"));

var DATE_FORMAT = 'MM/dd/yyyy';

var createMaskOptions = function createMaskOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      max = _ref.max,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? false : _ref$lazy;

  return {
    mask: _CustomDateMask.default,
    lazy: lazy,
    pattern: 'm/`d/`Y',
    blocks: {
      m: {
        mask: _CustomRangeMask.default,
        from: 1,
        to: 12,
        maxLength: 2,
        placeholderChar: '_'
      },
      d: {
        mask: _CustomRangeMask.default,
        from: 1,
        to: 31,
        maxLength: 2,
        placeholderChar: '_'
      },
      Y: {
        mask: _CustomRangeMask.default,
        from: 1900,
        to: max ? max.getFullYear() : 2099,
        placeholderChar: '_'
      }
    },
    format: function format(date) {
      return (0, _format2.default)(date, DATE_FORMAT);
    },
    parse: function parse(str) {
      return (0, _parse2.default)(str, DATE_FORMAT, new Date());
    },
    validate: function validate(value) {
      // february never has 30+ days
      if (/02\/3/.test(value)) {
        return false;
      } // validate full date


      if (value.length === 10 && !/[MDY]/.test(value)) {
        var parsedDate = (0, _parse2.default)(value, DATE_FORMAT, new Date());
        return (0, _isValid.default)(parsedDate) && (!max || max && (0, _isBefore.default)(parsedDate, max));
      } // return true so use is able to enter the rest of the date


      return true;
    }
  };
};

var defaultMaskOptions = createMaskOptions();
exports.defaultMaskOptions = defaultMaskOptions;

var DateInput = function DateInput(props) {
  var max = props.max,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["max"]);

  var _useState = (0, _react.useState)(function () {
    return createMaskOptions({
      max: max,
      lazy: true
    });
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      maskOptions = _useState2[0],
      setMaskOptions = _useState2[1];

  var getRawValue = (0, _react.useCallback)(function (mask) {
    var _mask$value$split = mask.value.split('/'),
        _mask$value$split2 = (0, _slicedToArray2.default)(_mask$value$split, 3),
        month = _mask$value$split2[0],
        day = _mask$value$split2[1],
        year = _mask$value$split2[2];

    setMaskOptions(createMaskOptions({
      mask: mask,
      lazy: !mask.unmaskedValue
    }));
    return {
      month: month,
      day: day,
      year: year
    };
  }, []);
  (0, _react.useEffect)(function () {
    setMaskOptions(createMaskOptions({
      max: max
    }));
  }, [max]);
  return /*#__PURE__*/_react.default.createElement(_MaskedInput.default, Object.assign({}, otherProps, {
    inputMode: "decimal",
    maskOptions: maskOptions,
    getRawValue: getRawValue
  }));
};

DateInput.defaultProps = {
  placeholder: 'MM/DD/YYYY'
};
DateInput.propTypes = {
  /**
   * The maximum date a user should be able to type into the Input.
   */
  max: (0, _propTypes.instanceOf)(Date),

  /**
   * @ignore
   */
  placeholder: _propTypes.string
};
var _default = DateInput;
exports.default = _default;
